'use strict';exports.__esModule = true;var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);

var _components = require('../../../components');

var _FullScreenPropertyCellGallery = require('./FullScreenPropertyCellGallery.scss');var styles = _interopRequireWildcard(_FullScreenPropertyCellGallery);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;} // Components
// Styles
var FullScreenPropertyCellGallery = function (_Component) {_inherits(FullScreenPropertyCellGallery, _Component);function FullScreenPropertyCellGallery() {var _temp, _this, _ret;_classCallCheck(this, FullScreenPropertyCellGallery);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.
    state = {
      index: 0 }, _this.


    next = function () {
      if (_this.state.index < _this.props.images.length) {
        _this.setState({ index: _this.state.index + 1 });
      }
      var width = _this.galleryContainer.offsetWidth;
      var transition = _this.props.isRtl ? width * (_this.state.index + 1) : -(width * (_this.state.index + 1));
      _this.galleryContainer.style.transform = 'translateX(' + transition + 'px)';
    }, _this.

    prev = function () {
      if (_this.state.index > 0) {
        _this.setState({ index: _this.state.index - 1 });
      }
      var width = _this.galleryContainer.offsetWidth;
      var transition = _this.props.isRtl ? width * (_this.state.index - 1) : -(width * (_this.state.index - 1));
      _this.galleryContainer.style.transform = 'translateX(' + transition + 'px)';
    }, _temp), _possibleConstructorReturn(_this, _ret);}FullScreenPropertyCellGallery.prototype.

  render = function render() {var _this2 = this;var _props =
    this.props,translate = _props.translate,images = _props.images,isRtl = _props.isRtl;var _ref =
    [this.state.index + 1, images.length],active = _ref[0],all = _ref[1];
    var outof = translate('propertyDetails', 'details', 'outOf');
    return (
      _react2.default.createElement('div', { className: styles.galleryWrapper },
        _react2.default.createElement('div', {
            ref: function ref(_ref2) {_this2.galleryContainer = _ref2;},
            className: styles.galleryContainer },

          images.map(function (image) {return _react2.default.createElement('img', { src: image, alt: '', key: image });})),

        _react2.default.createElement('div', { className: 'gallery' },
          _react2.default.createElement(_components.GalleryArrow, {
            position: isRtl ? 'left' : 'right',
            handleClick: this.next,
            isShown: this.state.index < images.length - 1,
            className: 'inlineGalleryArrow',
            isMobile: true }),

          _react2.default.createElement(_components.GalleryArrow, {
            position: isRtl ? 'right' : 'left',
            handleClick: this.prev,
            isShown: this.state.index > 0,
            className: 'inlineGalleryArrow',
            isMobile: true }),

          _react2.default.createElement('div', { className: styles.pagination },
            _react2.default.createElement('span', null, ' ', active, ' '),
            _react2.default.createElement('span', null, ' ', outof, ' '),
            _react2.default.createElement('span', null, ' ', all, ' ')))));




  };return FullScreenPropertyCellGallery;}(_react.Component);exports.default = FullScreenPropertyCellGallery;


FullScreenPropertyCellGallery.propTypes = {
  images: _propTypes2.default.array,
  isRtl: _propTypes2.default.bool,
  translate: _propTypes2.default.func };module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/FullScreenPropertyCell/FullScreenPropertyCellGallery/FullScreenPropertyCellGallery.js
// module id = 2694
// module chunks = 0